import { useMutation } from 'react-query';
import { wgApiSdk } from '../../../../app/src/features/api/wgApi';
import {
  recalculateYellowhiveQuotesBySessionIdAndProductId,
  RecalculateYellowhiveQuotesBySessionIdAndProductIdBody,
  RecalculateYellowhiveQuotesBySessionIdAndProductIdResponse,
} from 'wg-api-sdk';

export const postYellowhiveProductCalculate = async (
  sessionId: string,
  productId: string,
  payload: RecalculateYellowhiveQuotesBySessionIdAndProductIdBody,
): Promise<RecalculateYellowhiveQuotesBySessionIdAndProductIdResponse> => {
  const response = await recalculateYellowhiveQuotesBySessionIdAndProductId(
    {
      body: {
        coverages: payload.coverages,
        payment_interval: payload.payment_interval,
      },
      params: {
        path: {
          session_id: sessionId,
          product_id: productId,
        },
        query: {},
      },
    },
    wgApiSdk,
  );
  return response;
};

export const useYellowhiveProductCalculate = () => {
  return useMutation<
    RecalculateYellowhiveQuotesBySessionIdAndProductIdResponse,
    unknown,
    {
      sessionId: string;
      productId: string;
      payload: RecalculateYellowhiveQuotesBySessionIdAndProductIdBody;
    }
  >(({ sessionId, productId, payload }) =>
    postYellowhiveProductCalculate(sessionId, productId, payload),
  );
};
